// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable */
.LanguagePicker_dropdownContainer__0k5R4 {
  margin: 0 auto;
  position: relative;
  text-transform: uppercase;
}

.LanguagePicker_deletePadding__56C2z {
  padding-left: 5px;
  padding-right: 5px;
}

.LanguagePicker_dropdownHeader__rjgaP {
  gap: 14px;
  text-transform: uppercase;
}
.LanguagePicker_dropdownHeader__rjgaP .LanguagePicker_iconDown__tJ-E9 {
  display: none;
}
@media (md) {
  .LanguagePicker_dropdownHeader__rjgaP .LanguagePicker_iconWorld__0nVPU {
    display: none;
  }
}
@media (sm) {
  .LanguagePicker_dropdownHeader__rjgaP .LanguagePicker_iconDown__tJ-E9 {
    display: inline;
  }
}

.LanguagePicker_dropdownHeaderText__1sVLo {
  display: flex;
  align-items: center;
  gap: 8px;
}

.LanguagePicker_dropdownListContainer__jujPe {
  position: absolute;
  z-index: 100000;
  right: 0;
}

.LanguagePicker_dropdownList__POkpY {
  padding: 0;
  margin: 0;
  background: #e9e9e9;
  border: 1px solid #d4d4d4;
  box-sizing: border-box;
  border-radius: 4px;
}
.LanguagePicker_dropdownList__POkpY .LanguagePicker_listItem__YpkVQ {
  padding-left: 1em;
  list-style: none;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
.LanguagePicker_dropdownList__POkpY .LanguagePicker_listItem__YpkVQ:hover {
  background: #d9d9d9;
}

.LanguagePicker_listItem__YpkVQ:nth-child(odd) {
  background: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./src/app/components/LanguagePicker/LanguagePicker.module.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAAA,sBAAA;AAKA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,SAAA;EACA,yBAAA;AAHF;AAKE;EACE,aAAA;AAHJ;AAOI;EADF;IAEI,aAAA;EAJJ;AACF;AAQI;EADF;IAEI,eAAA;EALJ;AACF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANF;;AASA;EACE,kBAAA;EACA,eCfiB;EDgBjB,QAAA;AANF;;AASA;EACE,UAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AANF;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AANJ;AAQI;EACE,mBAAA;AANN;;AAWA;EACE,mBAAA;AARF","sourcesContent":["/* stylelint-disable */\n@import '@common/scss/_colors';\n@import '@common/scss/_variables';\n@import '@common/scss/_media';\n\n.dropdownContainer {\n  margin: 0 auto;\n  position: relative;\n  text-transform: uppercase;\n}\n\n.deletePadding {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.dropdownHeader {\n  gap: 14px;\n  text-transform: uppercase;\n\n  .iconDown {\n    display: none;\n  }\n\n  .iconWorld {\n    @media (md) {\n      display: none;\n    }\n  }\n\n  .iconDown {\n    @media (sm) {\n      display: inline;\n    }\n  }\n}\n\n.dropdownHeaderText {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dropdownListContainer {\n  position: absolute;\n  z-index: $top-most-z-index;\n  right: 0;\n}\n\n.dropdownList {\n  padding: 0;\n  margin: 0;\n  background: #e9e9e9;\n  border: 1px solid #d4d4d4;\n  box-sizing: border-box;\n  border-radius: 4px;\n\n  .listItem {\n    padding-left: 1em;\n    list-style: none;\n    padding: $padding-m $padding-l;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n\n    &:hover {\n      background: #d9d9d9;\n    }\n  }\n}\n\n.listItem:nth-child(odd) {\n  background: #f5f5f5;\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownContainer": `LanguagePicker_dropdownContainer__0k5R4`,
	"deletePadding": `LanguagePicker_deletePadding__56C2z`,
	"dropdownHeader": `LanguagePicker_dropdownHeader__rjgaP`,
	"iconDown": `LanguagePicker_iconDown__tJ-E9`,
	"iconWorld": `LanguagePicker_iconWorld__0nVPU`,
	"dropdownHeaderText": `LanguagePicker_dropdownHeaderText__1sVLo`,
	"dropdownListContainer": `LanguagePicker_dropdownListContainer__jujPe`,
	"dropdownList": `LanguagePicker_dropdownList__POkpY`,
	"listItem": `LanguagePicker_listItem__YpkVQ`
};
export default ___CSS_LOADER_EXPORT___;
